<template>
  <page-header-wrapper>
    <a-drawer
      :visible="true"
      placement="right"
      width="88%"
      :destroy-on-close="true"
      :title="$t('views.orderPayment.drawer.title')"
      @close="handleDrawerClose"
    >
      <order-payment-panel />
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import OrderPaymentPanel from './modules/OrderPaymentPanel'

export default {
  name: 'OrderPayment',
  components: {
    OrderPaymentPanel
  },
  methods: {
    handleDrawerClose () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>
